/* ECLIPSE STUDIOS* — Mobile-Korrekturen, 2026-07-28.
   Laeuft NACH hero-split.js und book-tap.js. Aendert am Desktop nichts.

   A) Header am Seitenanfang verborgen, erscheint beim Scrollen.
   B) Videos gegen Antippen, Controls und Fullscreen abgesichert.

   Bewusst NICHT enthalten: ein automatisches Fortsetzen bei "pause".
   hero-split.js pausiert die Videos absichtlich, wenn sie aus dem Bild
   scrollen und wenn die Slideshow weiterschaltet. Ein Auto-Resume wuerde
   dagegen arbeiten, versteckte Videos weiterlaufen lassen und Akku kosten.
   Da die Videos ab jetzt keine Taps mehr annehmen, kann sie ohnehin
   niemand mehr von Hand stoppen. */
(function(){
  'use strict';

  var MQ = window.matchMedia('(max-width:768px)');

  /* ---------- A) Header ---------- */
  var hd = document.getElementById('siteHead');
  if(hd){
    var TOP = 64; /* ab dieser Scrolltiefe erscheint der Header */
    var updHead = function(){
      if(!MQ.matches){ hd.classList.remove('hd-top'); return; }
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      hd.classList.toggle('hd-top', y < TOP);
    };
    window.addEventListener('scroll', updHead, { passive:true });
    window.addEventListener('resize', updHead);
    window.addEventListener('orientationchange', updHead);
    if(MQ.addEventListener){ MQ.addEventListener('change', updHead); }
    else if(MQ.addListener){ MQ.addListener(updHead); }
    updHead();
  }

  /* ---------- B) Videos ---------- */
  var swallow = function(e){ e.preventDefault(); e.stopPropagation(); };

  var harden = function(v){
    if(!v || v.getAttribute('data-es-hardened')) return;
    v.setAttribute('data-es-hardened','1');

    v.removeAttribute('controls');
    try{ v.controls = false; }catch(e){}
    try{ v.muted = true; v.defaultMuted = true; v.loop = true; }catch(e){}
    v.setAttribute('muted','');
    v.setAttribute('loop','');
    v.setAttribute('playsinline','');
    v.setAttribute('webkit-playsinline','');
    v.setAttribute('disablepictureinpicture','');
    v.setAttribute('controlslist','nodownload noplaybackrate nofullscreen');
    v.style.pointerEvents = 'none';

    /* Doppelte Absicherung fuer den Fall, dass eine Engine
       pointer-events auf Medienelementen ignoriert. */
    ['click','dblclick','touchstart','touchend','contextmenu'].forEach(function(t){
      v.addEventListener(t, swallow, true);
    });

    /* iOS kann Video ueber eigene Wege in den Vollbildmodus heben.
       Sollte das passieren, sofort wieder verlassen. */
    v.addEventListener('webkitbeginfullscreen', function(){
      try{ if(v.webkitExitFullscreen) v.webkitExitFullscreen(); }catch(e){}
    });
  };

  var sweep = function(){
    var vids = document.querySelectorAll('.hero video, .sp-half video, .hm-wrap video, .hm-slot video');
    Array.prototype.forEach.call(vids, harden);
  };

  sweep();

  /* Die Slideshow erzeugt ihr Video erst spaeter per JS. */
  if('MutationObserver' in window){
    var host = document.getElementById('heroMedia');
    if(host){
      new MutationObserver(sweep).observe(host, { childList:true, subtree:true });
    }
  }
  window.addEventListener('load', sweep);
})();
